var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"emptyOrderButton",on:{"click":function($event){return _setup.emits('onClick')}}},[(_vm.$slots.icon)?_c('div',{staticClass:"emptyOrderButton__icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }